module.exports = __webpack_public_path__ + "static/media/hand-point-left.e6bf260b.svg";